<template>
  <div>
    <HeroSection home />
    <TrustingCompaniesSection />
    <StepsSection view="home" />
    <TrustSection />
    <Testimonials v-if="testimonials.length > 0" :testimonials />
    <MoreReviewsStrip v-if="$branch.reviews.public" :links="$branch.reviews.links" />
    <CountriesOverviewSection :id="getSectionId('countries_overview')" />
    <BlogOverviewSection v-if="$branch.blog" />

    <ChatWidget />
  </div>
</template>

<script setup lang="ts">
import { getSectionId } from '~/helpers/routing';

const domain = useNuxtApp().$domain;
const { testimonials } = useTestimonials("home");
const { tt } = useLocalization();

usePageHead({
  title: tt('home_page.title', { domain }),
  description: tt('home_page.meta_desc', { domain }),
  alternateBranches: 'all',
});
</script>